var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon/Icon';
import { superEllipseIcon } from './styles';
export const sizesMapping = {
    120: 64,
    96: 48,
    88: 48,
    80: 48,
    72: 40,
    64: 40,
    56: 28,
    48: 24,
    40: 20,
    32: 20,
    24: 16,
    20: 14,
    16: 12,
};
export const SuperEllipseIcon = (_a) => {
    var { size = 64, icon, className } = _a, props = __rest(_a, ["size", "icon", "className"]);
    if (!icon) {
        return null;
    }
    return _jsx(Icon, Object.assign({ name: icon, size: sizesMapping[size] }, props, { className: superEllipseIcon({ className }) }));
};
